import Zoom from "react-medium-image-zoom";
import { Container, Image } from "react-bootstrap";
import "react-medium-image-zoom/dist/styles.css";

const photos = [
  "/images/main/optimized/room-resort.jpg",
  "/images/main/optimized/room-ac91e7cb.f10.webp",
  "/images/main/optimized/room-d7eb597f.f10.webp",
  "/images/main/optimized/room-8c8baf11.png",
  "/images/main/optimized/room-balcony.webp",
  "/images/main/optimized/new_room-5.JPG",
  "/images/main/optimized/new_room-6.JPG",
  "/images/main/optimized/home-chairs.JPG",
  "/images/main/optimized/new_room-8.JPG",
  "/images/main/optimized/new_room-9.JPG",
  "/images/main/optimized/new_room-10.JPG",
  "/images/main/optimized/room-IMG_20260118_152607.jpg",
  "/images/main/optimized/room-IMG_20260118_152608.jpg",
  "/images/main/optimized/room-IMG_20260118_152616.jpg",
  "/images/main/optimized/new_room-1.JPG",
  "/images/main/optimized/new_room-3.JPG",
  "/images/main/optimized/room-IMG_20260118_152601.jpg",
  "/images/main/optimized/room-bathroom.webp",
];

export default function Photos() {
  return (
    <>
      <Container
        className="d-flex flex-wrap justify-content-center"
        style={{ minHeight: "600px" }}
      >
        {photos.map((photo) => (
          <Zoom IconUnzoom={"div"}>
            <Image alt={photo} src={photo} style={{ maxWidth: "420px" }} />
          </Zoom>
        ))}
      </Container>
    </>
  );
}
